"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToFullProduct = exports.getSampleProductCode = exports.getParentProductCode = void 0;
const goToFullProduct = productCode => window.location.href = `/products/product?code=${productCode}`;
exports.goToFullProduct = goToFullProduct;
const getSampleProductCode = sample => sample?.isDiscontinued == null ? null : sample.productCode;
exports.getSampleProductCode = getSampleProductCode;
const getParentProductCode = parentProducts => parentProducts?.find(parent => parent?.isDiscontinued != null)?.productCode ?? null;
exports.getParentProductCode = getParentProductCode;
//# sourceMappingURL=utils.js.map